import styled from 'styled-components';
export const Container = styled.div`
  display: flex;

  flex-direction: column;
  width: 100%;
  opacity: ${({ active }) => (active ? '1' : '0')};
  visibility: ${({ active }) => (active ? 'visible' : 'hidden')};
  transition: opacity 0.5s ease;

  padding-bottom: 0.7rem;
`;

export const ListItem = styled.div`
  display: flex;
  flex-direction: column;
  width: 16.678125rem;
  max-height: 36rem;
  overflow: hidden;

  &:hover {
    overflow-y: auto;
    ::-webkit-scrollbar {
      width: 0.2rem;
    }
  }
  &:after {
    content: '';
    position: absolute;

    z-index: 1;
    bottom: 0;
    left: 0;
    pointer-events: none;
    background-image: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 1) 90%
    );

    width: 100%;
    height: 1.5rem;
  }
`;
export const Item = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1.765rem;
  justify-content: space-between;
  width: 16.678125rem;
`;

export const FileDiv = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 1.765rem;
  height: 1.765rem;
  border-radius: 0.512rem;
  background: #d4d6da;
  margin-right: 0.70625rem;
  margin-left: 0.8rem;
`;
export const ContentItem = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 10.375rem;
`;

export const Filename = styled.span`
  color: #212326;
  font-size: 0.7062rem;
  line-height: 0.893125rem;
  font-weight: 600;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
export const Size = styled.span`
  color: #7e858f;
  font-size: 0.7062rem;
  line-height: 0.815625rem;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const DownloadDiv = styled.div`
  cursor: pointer;
  margin-right: 0.8825rem;
`;
